// ===== CUSTOM CODE: Truncated Description Toggle =====

// Funzione per mostrare un elemento con effetto fadeIn
function fadeIn(element, duration = 400, callback) {
    element.style.opacity = 0;
    element.style.display = 'block';
    const startTime = performance.now();

    function animate(time) {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        element.style.opacity = progress;

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else if (callback) {
            callback();
        }
    }

    requestAnimationFrame(animate);
}

// Funzione per nascondere un elemento con effetto fadeOut
function fadeOut(element, duration = 400, callback) {
    const startTime = performance.now();

    function animate(time) {
        const elapsed = time - startTime;
        const progress = Math.min(elapsed / duration, 1);
        element.style.opacity = 1 - progress;

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            element.style.display = 'none';
            if (callback) {
                callback();
            }
        }
    }

    requestAnimationFrame(animate);
}

// Aggiungi evento solo se gli elementi esistono nella pagina
document.addEventListener('DOMContentLoaded', function() {
    const truncatedElement = document.querySelector('#truncated');
    const fullDescriptionElement = document.querySelector('#fullDescription');
    
    // Controllo di esistenza prima di aggiungere l'evento
    if (truncatedElement && fullDescriptionElement) {
        truncatedElement.addEventListener('click', function() {
            fadeOut(truncatedElement, 300, function() {
                fadeIn(fullDescriptionElement, 500);
            });
        });
    }
});
